import { EditOutline18Icon } from "@vygruppen/spor-icon-react";
import { EditProductionDeviationModal } from "features/CenterContent/RoleContent/ProductionDeviation/EditProductionDeviationModal";
import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { IconButton } from "shared/components/Spor";

type EditProductionDeviationButtonProps = {
  uuid: string;
};

export const EditProductionDeviationButton: FC<
  EditProductionDeviationButtonProps
> = ({ uuid }) => {
  const { t } = useTranslation();
  const [editProductionDeviationUuid, setEditProductionDeviationUuid] =
    useState<string | null>(null);
  return (
    <>
      {editProductionDeviationUuid && (
        <EditProductionDeviationModal
          uuid={editProductionDeviationUuid}
          onClose={() => setEditProductionDeviationUuid(null)}
        />
      )}
      <IconButton
        onClick={() => setEditProductionDeviationUuid(uuid)}
        size="xs"
        aria-label={t("Rediger")}
        variant="tertiary"
        icon={<EditOutline18Icon />}
      />
    </>
  );
};
